import { useCallback } from 'react';
import { useTranslation } from '../../i18n/LanguageContext';

/**
 * Texts of Alt Yüklenici / Tarife Yönetimi (`tariffs.*`). Stored values stay
 * Turkish ('Evet' / 'Hayır', 'Saat', 'Silinmiş proje'); these helpers only
 * label them. Excel and PDF files stay Turkish.
 */
const useTariffText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`tariffs.${key}`, vars), [t]);
  const yesNo = useCallback((value) => {
    if (value === 'Evet') return t('tariffs.yes');
    if (value === 'Hayır') return t('tariffs.no');
    return value || '';
  }, [t]);
  const typeLabel = useCallback((value) => (value === 'Saat' ? t('tariffs.types.hour') : value || ''), [t]);
  /** 'YYYY-MM-DD' (or any date text) → "12 Mart 2026" in the current language. */
  const formatDate = useCallback((value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString(locale, { day: '2-digit', month: 'long', year: 'numeric' });
  }, [locale]);
  const formatMoney = useCallback((amount, currency) => {
    const formatted = new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount || 0);
    return currency ? `${formatted} ${currency}` : formatted;
  }, [locale]);
  return { t, language, locale, label, yesNo, typeLabel, formatDate, formatMoney };
};

export default useTariffText;
